export const FIELD_WIDTH = {
  THIRD: '1/3',
  HALF: '1/2',
  TWO_THIRDS: '2/3',
  FULL: 'full',
} as const;

export type FieldWidth = (typeof FIELD_WIDTH)[keyof typeof FIELD_WIDTH];

export interface FieldStyles {
  width?: FieldWidth;
}

export const FIELD_WIDTHS = Object.values(FIELD_WIDTH);

export const FIELD_WIDTH_COLUMNS: Record<FieldWidth, number> = {
  [FIELD_WIDTH.THIRD]: 2,
  [FIELD_WIDTH.HALF]: 3,
  [FIELD_WIDTH.TWO_THIRDS]: 4,
  [FIELD_WIDTH.FULL]: 6,
};
